import ___svg_removeformatSvg from '../svg/removeformat.svg';
import { removeFormat as removeFormat_1 } from './removeFormat.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import { callFormatApi } from 'owa-editor/lib/utils/callFormatApi';
import { ClearFormatMode } from 'roosterjs-editor-types';
import { isFeatureEnabled } from 'owa-feature-flags';

const removeFormat: RibbonButton = {
    key: 'removeFormat',
    title: () => loc(removeFormat_1),
    imageSrc: ___svg_removeformatSvg,
    onExecute: editorViewState => {
        isFeatureEnabled('cmp-clearformat-autodetect')
            ? callFormatApi(editorViewState, 'clearFormat', [ClearFormatMode.AutoDetect])
            : callFormatApi(editorViewState, 'clearFormat');
    },
    buttonState: formatState =>
        formatState.hasReadonlyContent ? RibbonButtonState.Disabled : RibbonButtonState.Normal,
};

export default removeFormat;
